import * as React from 'react';
import { Watchlist } from '../../../../watchlist/build';
import { AppContext, AppContextType } from '../../AppContextType';
import { Product, ProductInterface } from '../../Model/Product';
import { Trans } from '../Trans';

interface WatchlistCellProps {
    product: ProductInterface,
}

interface State {
    isOnList: boolean
}

export class WatchlistCell extends React.PureComponent<WatchlistCellProps, State> {
    public static contextType = AppContextType;
    public context: AppContext<Product> = {} as AppContext<Product>;

    constructor(props: WatchlistCellProps, context: any) {
        super(props, context);
        this.context = context;
        this.handleClick = this.handleClick.bind(this);
        const watchlist = this.getWatchlist();
        const isOnList = watchlist.has(this.props.product);

        this.state = {isOnList};
    }

    public render() {
        const isOnList = this.state.isOnList;
        const className = 'pf-wl-button ' + (isOnList ? 'pf-wl-remove' : 'pf-wl-add');

        return <td colSpan={99}>
            <div className={className} onClick={this.handleClick}>
                <div className="pf-wl-icon">
                    {isOnList ? <i className="fas fa-heart"/> : <i className="far fa-heart"/>}
                </div>
                <div className="pf-wl-text">
                    <Trans>Produkt merken</Trans>
                </div>
            </div>
        </td>;
    }

    private getWatchlist(): Watchlist {
        return this.context.serviceLocator.get('watchlist');
    }

    private handleClick() {
        const product = this.props.product;
        const watchlist = this.getWatchlist();
        if (watchlist.has(product)) {
            watchlist.remove(product);
            this.setState({isOnList: false});
        } else {
            watchlist.add(product);
            this.setState({isOnList: true});
        }
    }
}
